import { createAsyncThunk } from "@reduxjs/toolkit";
import { getForms, getForm, createForm, updateForm, deleteForm, createSubmission, updateSubmission } from "api/formioApi";
import { logger } from "helpers/logger";

export const fetchFormioFormsThunk = createAsyncThunk("formio/fetchForms", async (_, { rejectWithValue, signal }) => {
	try {
		const response = await getForms(signal);
		return response;
	} catch (error) {
		if (error.name === "AbortError") {
			logger.info("🚫 Request cancelled");
			return rejectWithValue("cancelled");
		}
		logger.error("❌ Failed to fetch forms:", error);
		return rejectWithValue(error.message || "Failed to fetch forms");
	}
});

export const fetchFormioFormThunk = createAsyncThunk("formio/fetchForm", async ({ formId, formPath }, { rejectWithValue, signal }) => {
	try {
		const response = await getForm({ formId, formPath }, signal);
		return response;
	} catch (error) {
		if (error.name === "AbortError") {
			logger.info("🚫 Request cancelled");
			return rejectWithValue("cancelled");
		}
		logger.error("❌ Failed to fetch form:", error);
		return rejectWithValue(error.message || "Failed to fetch form");
	}
});

export const createFormioFormThunk = createAsyncThunk("formio/createForm", async ({ formData }, { rejectWithValue, signal }) => {
	try {
		const response = await createForm(formData, signal);
		return response;
	} catch (error) {
		if (error.name === "AbortError") {
			logger.info("🚫 Request cancelled");
			return rejectWithValue("cancelled");
		}
		logger.error("❌ Failed to create form:", error);
		return rejectWithValue(error.message || "Failed to create form");
	}
});

export const updateFormioFormThunk = createAsyncThunk("formio/updateForm", async ({ formId, formData }, { rejectWithValue, signal }) => {
	try {
		const response = await updateForm(formId, formData, signal);
		return response;
	} catch (error) {
		if (error.name === "AbortError") {
			logger.info("🚫 Request cancelled");
			return rejectWithValue("cancelled");
		}
		logger.error("❌ Failed to update form:", error);
		return rejectWithValue(error.message || "Failed to update form");
	}
});

export const deleteFormioFormThunk = createAsyncThunk("formio/deleteForm", async ({ formId }, { rejectWithValue, signal }) => {
	try {
		const response = await deleteForm(formId, signal);
		return response;
	} catch (error) {
		if (error.name === "AbortError") {
			logger.info("🚫 Request cancelled");
			return rejectWithValue("cancelled");
		}
		logger.error("❌ Failed to delete form:", error);
		return rejectWithValue(error.message || "Failed to delete form");
	}
});

export const submitFormioSubmissionThunk = createAsyncThunk("formio/submitSubmission", async ({ formId, submissionId, submissionData, processInstanceId, taskId }, { rejectWithValue, signal }) => {
	try {
		// If continuing an existing submission, PATCH it (backend merges these
		// fields into its current payload); otherwise POST a brand new one.
		const response = submissionId
			? await updateSubmission(formId, submissionId, submissionData, processInstanceId, taskId, signal)
			: await createSubmission(formId, submissionData, processInstanceId, taskId, signal);
		return response;
	} catch (error) {
		if (error.name === "AbortError") {
			logger.info("🚫 Request cancelled");
			return rejectWithValue("cancelled");
		}
		logger.error("❌ Failed to submit form:", error);
		return rejectWithValue(error.message || "Failed to submit form");
	}
});
